/**
 * joyspaceFolder 文件夹卡片
 */
import React, { useEffect, useState } from "react";
import { EmployeeAttribute, GroupAttribute, MessageStatus, SessionType } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import { WithTranslation } from "react-i18next";
import i18n from "@/i18n";
import "./index.less";
import { changeEgovUrl } from "@/utils/tools";
import { message as Message } from "antd";
import { JoyspaceFolderMessageBody } from "@jd/jdee.im.sdk/lib/es/protocol/message/JoyspaceFile";
import { isSameEmployee } from "@/utils/user";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import { shareJoyspaceFiles } from "@/components/Joyspace/api/page";
import ImService from "@/server/ImService";
import MessageCard, { OriginType } from "@/components/chat/message/message-components/MessageCard";
import { getPageIconByPagetype } from "@/utils/chat/joyspace-file";
import PermissionSelect from "@/components/Joyspace/components/PermissionSelect";
import { useHistory } from "react-router-dom";
import { FileType } from "@/components/Joyspace/types";
import API from "@/components/Joyspace/api";
import { FocusSDK } from "@/utils";
import { isChatPage } from "@/utils/chat/index";
interface JoyspaceFolderProps {
  message: JoyspaceFolderMessageBody;
  sessionType: SessionType;
  sendType: MessageSendType;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
  count?: number;
  updateSessionMessageMid?: Function;
  addFolderInfo?: Function;
}

type ISJoyspaceFilePropsProps = Readonly<JoyspaceFolderProps & WithTranslation & ChatState>;

// eslint-disable-next-line complexity
function JoyspaceFolder(props: ISJoyspaceFilePropsProps | any) {
  const [currentPermission, setCurrentPermission] = useState(
    // @ts-ignore
    props.message.currentPermission || 2
  );
  useEffect(() => {
    setCurrentPermission(props.message.currentPermission);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.message.currentPermission]);
  const { data } = props.message;
  const {
    sendType,
    onReady,
    selectedSession,
    updateSessionMessageMid,
    currentEmployee,
    updateSessionMessagesTimestamp,
    addFolderInfo
  } = props;
  const setPermission = async (permission: number) => {
    const selectedSession = props.selectedSession;
    let groups;
    let users;
    let info = selectedSession.info as GroupAttribute | EmployeeAttribute;
    if (selectedSession.isGroup) {
      groups = [{ gid: (info as GroupAttribute).gid, permission_type: permission }];
    } else {
      users = [
        {
          userId: (info as EmployeeAttribute).userId,
          teamId: (info as EmployeeAttribute).teamId,
          permission_type: permission
        }
      ];
    }
    // 修改消息体
    const imService = ImService.getInstance();
    if (selectedSession) {
      const sessionId = (selectedSession as any).sessionId; // 参数1
      const _message = { ...props.message };
      // console.log(_message, '_message========>');
      const res = await shareJoyspaceFiles({
        folder_ids: [_message.fileId],
        to_eepaas_users: users,
        to_groups: groups
      });
      const folderId = _message.fileId;
      if (res[folderId].status === "faild" || res[folderId].status === "failed") {
        Message.error(res[folderId].errMsg);
      }
      const isDelPage = Array.isArray(res[folderId].folder.permissions);
      const body = {
        ..._message,
        permission: isDelPage ? _message.permission : -1,
        currentPermission: isDelPage ? permission : -1
      };
      setCurrentPermission(() => {
        return isDelPage ? permission : -1;
      });
      const result = await imService.updateJoySpaceLink(
        sessionId,
        selectedSession.mid || selectedSession.lastMid,
        body
      );

      if (result) {
        // 修改渲染数据
        updateSessionMessageMid?.({
          sessionId: sessionId,
          sendResult: {
            body: { ...body }
          }
        });
        await updateSessionMessagesTimestamp({
          timestamp: new Date().getTime()
        });
      }
    }
  };
  const handleMenuClick = (key = "2") => {
    const permission = parseInt(key, 10);
    if (permission === currentPermission) {
      return;
    }
    setPermission(permission);
  };
  // 兼容移动端的神奇代码
  if (data?.[0]?.joySpaceLinkDetail) {
    // @ts-ignore
    const joySpaceLinkDetail = data[0].joySpaceLinkDetail || {};
    props.message.fileName = joySpaceLinkDetail.fileName;
    props.message.pageType = joySpaceLinkDetail.pageType;
    props.message.webUrl = joySpaceLinkDetail.webUrl;
    props.message.content = joySpaceLinkDetail.content;
    props.message.iconUrl = joySpaceLinkDetail.iconUrl;
    props.message.fileId = joySpaceLinkDetail.fileId;
  }
  const {
    fileName,
    fileId,
    pageType,
    content,
    iconUrl,
    // @ts-ignore
    sender,
    // @ts-ignore
    senderTeamId,
    // @ts-ignore
    permission = 2
  } = props.message;
  const message = props.message;
  useEffect(() => {
    if (
      (sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF) &&
      // @ts-ignore
      message.status === MessageStatus.INIT
    ) {
      onReady({ beginSend: true, messageExtend: {} });
    }
  }, [sendType, message, onReady]);
  // 这块可能不满足所有的业务场景
  const isOwnSendMessage: boolean = isSameEmployee(
    currentEmployee,
    typeof sender === "string" ? { userId: sender, teamId: senderTeamId } : sender
  );
  const history = useHistory();

  const handleJoyspaceLink = async () => {
    const res = await API.categories.info(fileId);
    const { message } = props;
    console.log(res, " resresresresresresresresres=>");
    let folderInfo = res
      ? [res]
      : [
          {
            id: fileId,
            parent: "",
            space_id: fileId,
            type: 12,
            full_name: message?.fileName,
            full_path: fileId,
            name: message?.fileName,
            origin: "messageCard",
            permissions: res ? res.permissions : []
          }
        ];
    // 解决打开文件夹无权限问题及删除问题
    addFolderInfo(folderInfo);
    const url = `/joyspace/teamspace?categoryId=${fileId}`;
    if (isChatPage()) {
      FocusSDK.launchNewSession(url);
    } else {
      history.push(url);
    }
  };
  const maxPermi = selectedSession.isGroup && permission === 0 ? 1 : permission;
  return (
    <div className="joyspace-folder-message-content">
      <MessageCard
        origin={OriginType.JoySpace}
        title={fileName ? `${fileName}` : "无标题"}
        imageSrc={changeEgovUrl(iconUrl || getPageIconByPagetype(pageType))}
        imgStyle={{ width: "auto", height: 40 }}
        handleDetail={() => {
          handleJoyspaceLink();
        }}
        footerChildren={() => {
          return (
            permission !== -1 &&
            isOwnSendMessage &&
            currentPermission !== -1 && (
              <div className="share-menu">
                <span>{i18n.t("joyspace:teamspace.granting-permission")}</span>
                <div className="drop-down">
                  {(permission === 0 || permission === 1) &&
                  (sendType === MessageSendType.OWNER || MessageSendType.SELF) ? (
                    <PermissionSelect
                      type={FileType.Folder}
                      onChange={handleMenuClick}
                      permissionType={maxPermi}
                      propsValue={currentPermission}
                    />
                  ) : (
                    <span>
                      {(sendType === MessageSendType.OWNER || sendType === MessageSendType.SELF
                        ? permission
                        : currentPermission) === 2
                        ? i18n.t("joyspace:teamspace.readonly")
                        : i18n.t("joyspace:teamspace.edit")}
                    </span>
                  )}
                </div>
              </div>
            )
          );
        }}
      />
    </div>
  );
}
function mapDispatchToProps(dispatch: any) {
  return {
    updateSessionMessageMid(data: { sendResult: any; sessionId: String }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    updateSessionMessagesTimestamp(data: { timestamp: number }) {
      dispatch({ type: "chat/updateSessionMessagesTimestamp", payload: data });
    },
    addFolderInfo(list: any) {
      return dispatch({ type: "joyspace/addFolderInfo", payload: { list } });
    }
  };
}
function mapStateToProps({ chat }: { chat: ChatState }) {
  // console.log(chat.sessionMessageMap, 'chat.sessionMessageMap');
  return {
    selectedSession: chat.selectedSession,
    currentEmployee: chat.currentEmployee
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(JoyspaceFolder);
